import { nanoid } from "nanoid";
import { useCallback } from "react";
import { useSceneStore } from "../store/sceneStore";
import { arrayBufferToBase64 } from "../lib/binary";
import { detectFormat } from "../lib/loaders";
import type { SceneObjectData } from "../types";

const DEFAULT_COLORS = ["#5b8cff", "#ff8a5b", "#5bffb0", "#ffd95b", "#c95bff"];

export function useFileImport() {
  const addObject = useSceneStore((s) => s.addObject);
  const objectCount = useSceneStore((s) => s.objects.length);

  return useCallback(
    async (files: FileList | File[]) => {
      const list = Array.from(files);
      let index = objectCount;
      for (const file of list) {
        const format = detectFormat(file.name);
        if (!format) {
          console.warn(`Übersprungen: ${file.name} (unbekanntes Format, nur .stl/.obj unterstützt)`);
          continue;
        }
        const buffer = await file.arrayBuffer();
        const fileBase64 = arrayBufferToBase64(buffer);
        const GRID_SPACING = 60;
        const GRID_COLUMNS = 5;
        const object: SceneObjectData = {
          id: nanoid(),
          name: file.name.replace(/\.(stl|obj)$/i, ""),
          format,
          fileBase64,
          position: [(index % GRID_COLUMNS) * GRID_SPACING, 0, Math.floor(index / GRID_COLUMNS) * GRID_SPACING],
          rotation: [0, 0, 0],
          scale: [1, 1, 1],
          color: DEFAULT_COLORS[index % DEFAULT_COLORS.length],
          roughness: 0.5,
          metalness: 0.1,
          visible: true,
        };
        addObject(object);
        index += 1;
      }
    },
    [addObject, objectCount],
  );
}
